import type { Route } from '!/router'
import * as info from '~/routes/settings/info'
import * as root from '~/routes/settings/root'
import * as contentSettings from '~/routes/settings/content-settings'
import * as videoAudio from '~/routes/settings/video-audio'

export const route: Route = {
  children: [
    {
      path: '',
      component: [root.Title, root.SettingsPage],
      init: root.model.init,
    },
    {
      path: '/info',
      component: [info.Title, info.SettingsInfoPage],
      init: info.model.init,
    },
    {
      path: '/content-settings',
      component: [
        contentSettings.Title,
        contentSettings.ContentSettingsSubPage,
      ],
      init: contentSettings.model.init,
    },
    {
      path: '/video-audio',
      component: [videoAudio.Title, videoAudio.SettingsVideoAudioPage],
      init: videoAudio.model.init,
    },
  ],
}
